export const MARKETS_GET_DATA = "markets/GET_DATA";